module.exports = __webpack_public_path__ + "assets/HKNova-ExtraLight.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraLight.woff2
// module id = 113
// module chunks = 0